export default function CentriDiEccellenzaImages() {
  return (
    <div className="snf-lx-components-centri-di-eccellenza-image-bar">
      <>
        <div className="row justify-content-around w-100 m-0">
          <img
            className="w-100 image"
            alt="Immagine innovation center"
            src="/images/innovation-center.svg"
          />
          {/* <div className="col-auto margin3 ">
          <div className="position-relative">
            <img
              className="img "
              alt="Immagine centri eccellenza 1"
              src="/images/centri-eccellenza-1.png"
            />
            <div className="snf-text-color-white text card-img-overlay ">
              <p className="snf-font-96 snf-font-w6 quotes">“</p>
              <p className="snf-font-12 card-text margin3">
                {intl.formatMessage({
                  defaultMessage:
                    'Questa iniziativa si inserisce nel programma “Accelera Italia” che IBM sta portando avanti da mesi nel nostro Paese. Ed è anche un esempio positivo di cosa significa concretamente “fare sistema”, coinvolgendo le Istituzioni, le imprese del territorio, le università e le giovani generazioni per favorire l’innovazione e lo sviluppo di nuove professionalità che integrino le tecnologie esponenziali ormai essenziali per essere competitivi in uno scenario globale'
                })}
              </p>
              <p className="snf-font-12 snf-font-w6 card-text">
                {intl.formatMessage({
                  defaultMessage: 'Enrico Cereda, Presidente e Amministratore Delegato IBM Italia'
                })}
              </p>
            </div>
          </div>
        </div>

        <div className="col-auto margin3">
          <img
            className="img "
            alt="Immagine centri eccellenza 1"
            src="/images/centri-eccellenza-2.png"
          />
        </div> */}
        </div>
      </>
    </div>
  );
}
